import classNames from "classnames/bind";
import styles from "./PlaySound.module.css";
import { useState } from "react";
import { Sound } from "../Icons/SettingNotification/Sound";

const cx = classNames.bind(styles);

function PlaySound({ soundPath }) {
    const [playing, setPlaying] = useState(false);
    const handlePlay = () => {
        // // console.log(soundPath);
        setPlaying(true);
        setTimeout(() => {
            setPlaying(false)
        }, [2000])
    }
    return (
        <span onClick={handlePlay} className={cx("playsound-btn")}>
            <Sound color={playing ? "#0040ff" : "black"} />
        </span>
    )
}

export default PlaySound;